import { inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, of, switchMap } from 'rxjs';

import { AiProvidersService } from './api/ai-providers.service';
import { AiProvidersActions } from './ai-providers.actions';

export class AiProvidersEffects {
  private readonly actions$ = inject(Actions);
  private readonly svc = inject(AiProvidersService);

  load$ = createEffect(() =>
    this.actions$.pipe(
      ofType(AiProvidersActions.getAIProviders),
      switchMap(({ tenantUuid, subscriptionUuid }) =>
        this.svc.getAiProviders(tenantUuid).pipe(
          map((aiProviders) => {
            return AiProvidersActions.loadSuccess({ aiProviders });
          }),
          catchError((error) => of(AiProvidersActions.loadFailure({ error }))),
        ),
      ),
    ),
  );
}
